export const SET_HRES82E_INDEX_DISP = 'SET_HRES82E_INDEX_DISP'
export const GET_HRES82E_INDEX_DISP = 'GET_HRES82E_INDEX_DISP'
export const SET_HRES82E_ROOM_DETAIL_DISP = 'SET_HRES82E_ROOM_DETAIL_DISP'
export const GET_HRES82E_ROOM_DETAIL_DISP = 'GET_HRES82E_ROOM_DETAIL_DISP'
export const SET_HRES82E_DETAIL_DISP = 'SET_HRES82E_DETAIL_DISP'
export const GET_HRES82E_DETAIL_DISP = 'GET_HRES82E_DETAIL_DISP'
export const SET_HRES82E_CALENDAR_DETAIL_DISP = 'SET_HRES82E_CALENDAR_DETAIL_DISP'
export const GET_HRES82E_CALENDAR_DETAIL_DISP = 'GET_HRES82E_CALENDAR_DETAIL_DISP'
export const SET_HRES82E_RESERVE_DISP = 'SET_HRES82E_RESERVE_DISP'
export const GET_HRES82E_RESERVE_DISP = 'GET_HRES82E_RESERVE_DISP'
export const SET_HRES82E_COLUMNS = 'SET_HRES82E_COLUMNS'
export const GET_HRES82E_COLUMNS = 'GET_HRES82E_COLUMNS'
export const SET_HRES82E_LABELS = 'SET_HRES82E_LABELS'
export const GET_HRES82E_LABELS = 'GET_HRES82E_LABELS'
export const RECEIVED_HRES82E_COLUMNS_LABELS = 'RECEIVED_HRES82E_COLUMNS_LABELS'
export const SET_HRES82E_INDEX = 'SET_HRES82E_INDEX'
export const GET_HRES82E_INDEX = 'GET_HRES82E_INDEX'
export const RECEIVED_HRES82E_INDEX = 'RECEIVED_HRES82E_INDEX'
export const SET_HRES82E_ROOM_DETAIL = 'SET_HRES82E_ROOM_DETAIL'
export const GET_HRES82E_ROOM_DETAIL = 'GET_HRES82E_ROOM_DETAIL'
export const RECEIVED_HRES82E_ROOM_DETAIL = 'RECEIVED_HRES82E_ROOM_DETAIL'
export const SET_HRES82E_CALENDAR = 'SET_HRES82E_CALENDAR'
export const GET_HRES82E_CALENDAR = 'GET_HRES82E_CALENDAR'
export const RECEIVED_HRES82E_CALENDAR = 'RECEIVED_HRES82E_CALENDAR'
export const SET_HRES82E_CALENDAR_DETAIL = 'SET_HRES82E_CALENDAR_DETAIL'
export const GET_HRES82E_CALENDAR_DETAIL = 'GET_HRES82E_CALENDAR_DETAIL'
export const RECEIVED_HRES82E_CALENDAR_DETAIL = 'RECEIVED_HRES82E_CALENDAR_DETAIL'
export const RECEIVED_HRES82E_RESERVE_CREATE = 'RECEIVED_HRES82E_RESERVE_CREATE'
export const SET_HRES82E_RESERVE_DETAIL = 'SET_HRES82E_RESERVE_DETAIL'
export const GET_HRES82E_RESERVE_DETAIL = 'GET_HRES82E_RESERVE_DETAIL'
export const RECEIVED_HRES82E_RESERVE_DETAIL = 'RECEIVED_HRES82E_RESERVE_DETAIL'
export const SET_HRES82E_INDEX_SELECTED = 'SET_HRES82E_INDEX_SELECTED'
export const GET_HRES82E_INDEX_SELECTED = 'GET_HRES82E_INDEX_SELECTED'
export const SET_HRES82E_CALENDAR_SELECTED = 'SET_HRES82E_CALENDAR_SELECTED'
export const GET_HRES82E_CALENDAR_SELECTED = 'GET_HRES82E_CALENDAR_SELECTED'
export const TOGGLE_HRES82E_PAGE = 'TOGGLE_HRES82E_PAGE'
export const SET_HRES82E_DATE_SELECTED = 'SET_HRES82E_DATE_SELECTED'
export const GET_HRES82E_DATE_SELECTED = 'GET_HRES82E_DATE_SELECTED'
export const POST_HRES82E_RESERVE_CANCEL = 'POST_HRES82E_RESERVE_CANCEL'
export const POST_HRES82E_RESERVE_SAVE = 'POST_HRES82E_RESERVE_SAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres82e/mutation-types.js